import { render, staticRenderFns } from "./EditInternalDashboard.vue?vue&type=template&id=08a3b703&scoped=true"
import script from "./EditInternalDashboard.vue?vue&type=script&lang=js"
export * from "./EditInternalDashboard.vue?vue&type=script&lang=js"
import style0 from "./EditInternalDashboard.vue?vue&type=style&index=0&id=08a3b703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a3b703",
  null
  
)

export default component.exports